export enum LogLevel {
    Trace = 0,
    Info = 2,
    Warn = 3,
    Error = 4,
    Fatal = 5,
}

export interface ILog {
    id: number;
    time: Date;
    level: 'Trace' | 'Info' | 'Warn' | 'Error' | 'Fatal';
    processName: string;
    user: string;
    message: string;
    rawMessage: string;
    robotName: string;
    jobKey: string;
    machineId: number;
    machineName: string;
}
